import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledNoResultsFoundIllustration = styled.svg`
  --color-white: ${({ theme }) => theme.color.additional.light.value};
  --color-gray-50: ${({ theme }) => theme.color.gray[50].value};
  --color-gray-100: ${({ theme }) => theme.color.gray[100].value};
  --color-gray-200: ${({ theme }) => theme.color.gray[200].value};
  --color-gray-300: ${({ theme }) => theme.color.gray[300].value};
  --color-gray-400: ${({ theme }) => theme.color.gray[400].value};
  --color-gray-500: ${({ theme }) => theme.color.gray[500].value};
  --color-gray-600: ${({ theme }) => theme.color.gray[600].value};
  --color-gray-700: ${({ theme }) => theme.color.gray[700].value};
  --color-gray-800: ${({ theme }) => theme.color.gray[800].value};
  --color-gray-900: ${({ theme }) => theme.color.gray[900].value};

  .grass-1,
  .grass-2,
  .lines,
  .tree {
    fill: var(--color-gray-100);
  }

  .help,
  .search-a-path {
    fill: var(--color-gray-200);
  }
`;

const NoResultsFoundIllustration = ({
  className = undefined,
  dataTestId = undefined,
  size = 400,
  svgTitle = 'No Results Found',
  ...other
}) => {
  return (
    <StyledNoResultsFoundIllustration
      className={className}
      data-testid={dataTestId ? `${dataTestId}-no-results-found` : 'no-results-found-svg'}
      width={size}
      height={size}
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      {svgTitle && <title>{svgTitle}</title>}
      <g className="illustration-no-result-found">
        <g className="illustration-no-result-found-2">
          <g className="ground">
            <path
              className="ellipse-20"
              opacity="0.3"
              d="M368 352C368 352 284 352 200 352C116 352 32 352 32 352C32 352 72.32 272 200 272C325.16 272 368 352 368 352Z"
              fill="url(#ground_gradient_fill_rule)"
            />
            <path
              className="grass-2"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M311.988 295.155C312.074 294.88 312.147 294.606 312.206 294.332C313.143 289.965 310.983 283.863 310.27 283.196C309.31 283.463 305.026 287.029 303.787 291.697C302.85 296.064 304.654 301.832 305.723 302.833C305.723 302.833 305.723 302.833 305.724 302.833C305.707 302.942 305.702 303.039 305.708 303.123C307.186 304.084 313.649 304.147 317.381 302.222C321.453 300.121 324.354 294.811 324.288 293.904C323.313 293.414 317.159 292.722 312.615 294.805C312.403 294.914 312.194 295.031 311.988 295.155Z"
            />
            <path
              className="tree"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M88.8749 292.925C88.7718 294.302 88.6745 295.646 88.5798 296.954C87.6037 310.441 86.9117 320 83.1932 320C80.9484 320 80.1408 313.726 79.2941 300.953C77.8338 300.902 70.5831 299.934 68.8364 293.649C67.4023 288.488 67.6496 276.338 70.8624 276.338C72.9741 276.338 73.2814 278.945 73.6429 282.012C74.0884 285.791 74.6161 290.268 78.7047 291.424C78.6955 291.27 78.6863 291.116 78.677 290.961C78.677 288.178 78.6206 285.268 78.5644 282.365L78.5644 282.365C78.3075 269.102 78.0537 256 83.1932 256C87.304 256 88.4663 265.228 88.7796 275.952C92.6072 275.19 93.1673 270.85 93.6779 266.894C94.1411 263.304 94.5636 260.03 97.3484 260.03C101.121 260.03 100.239 272.24 98.5553 277.447C96.6205 283.429 90.8684 285.481 88.8891 285.784C88.8883 286.953 88.885 288.112 88.8818 289.253V289.253V289.254C88.8783 290.505 88.8749 291.732 88.8749 292.925Z"
            />
            <path
              className="grass-1"
              d="M72.2723 307.805C74.185 311.828 74.3596 318.537 73.5248 320C72.2723 320 67.6804 316.585 65.5932 312.195C63.5059 307.317 63.9234 300.976 64.3409 300C65.1757 300 70.185 303.415 72.2723 307.805Z"
            />
          </g>
          <g className="secondary-item">
            <path
              className="help"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M110.616 308.493C102.547 312.084 98.915 321.548 102.508 329.616C106.101 337.684 115.566 341.317 123.634 337.725C131.703 334.133 135.335 324.67 131.742 316.601C128.149 308.533 118.684 304.901 110.616 308.493ZM123.143 332.689L120.219 333.99L118.917 331.066L121.841 329.765L123.143 332.689ZM121.125 320.015L120.408 321.946C119.831 323.481 119.564 324.651 120.54 326.843L117.617 328.145L117.291 327.414C116.575 325.806 116.582 324.052 117.159 322.516L118.152 319.868C118.458 319.101 118.454 318.227 118.096 317.423C117.38 315.815 115.479 315.085 113.871 315.801C112.263 316.517 111.533 318.418 112.249 320.026L109.326 321.327C107.888 318.097 109.339 314.316 112.569 312.878C115.799 311.44 119.581 312.891 121.019 316.121C121.592 317.408 121.587 318.811 121.125 320.015Z"
            />
            <path
              className="cloud"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M336.576 97.1525H336.615C340.696 97.1525 344.609 98.7775 347.494 101.67C350.379 104.563 352 108.486 352 112.576C352 116.667 350.379 120.59 347.494 123.482C344.609 126.375 340.696 128 336.615 128H290.901C288.419 128 285.961 127.51 283.668 126.558C281.375 125.605 279.291 124.21 277.536 122.45C273.991 118.896 272 114.076 272 109.051C272 104.025 273.991 99.2054 277.536 95.6518C280.876 92.3029 285.338 90.3369 290.037 90.1215C293.917 81.7938 302.252 76 312 76C324.319 76 334.48 85.2446 336.038 97.1849L336.576 97.1525ZM328.264 106.847V102C328.264 97.6756 326.55 93.5284 323.5 90.4706C320.45 87.4128 316.313 85.6949 312 85.6949C303.869 85.6949 297.199 91.6281 295.93 99.3591L295.672 100.931L294.178 100.387C293.15 100.012 292.037 99.7966 290.901 99.7966C288.453 99.7966 286.105 100.772 284.374 102.507C282.643 104.243 281.67 106.596 281.67 109.051C281.67 111.505 282.643 113.859 284.374 115.595C286.105 117.33 288.453 118.305 290.901 118.305H336.615C338.131 118.305 339.584 117.702 340.656 116.627C341.728 115.553 342.33 114.096 342.33 112.576C342.33 111.057 341.728 109.6 340.656 108.525C339.584 107.451 338.131 106.847 336.615 106.847H328.264Z"
              fill="var(--color-gray-50)"
            />
          </g>
          <g className="lens-primary-item">
            <path
              className="lines"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M121.089 122.36C118.831 123.664 118.057 126.552 119.361 128.81L130.494 148.095C131.798 150.353 134.685 151.127 136.943 149.823C139.201 148.52 139.975 145.632 138.672 143.374L127.538 124.089C126.234 121.83 123.347 121.057 121.089 122.36ZM91.3964 154.072C89.5206 152.261 89.4684 149.272 91.2797 147.396C93.091 145.521 96.08 145.468 97.9558 147.28L113.975 162.747C115.851 164.559 115.903 167.547 114.092 169.423C112.281 171.299 109.292 171.351 107.416 169.54L91.3964 154.072ZM77.5382 192.377C75.0318 191.659 73.5826 189.044 74.3014 186.538C75.0201 184.032 77.6346 182.582 80.141 183.301L101.547 189.439C104.054 190.157 105.503 192.772 104.784 195.278C104.065 197.784 101.451 199.234 98.9444 198.515L77.5382 192.377Z"
            />
            <g className="lens">
              <path
                className="search-a-path"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M254.409 269.32H245.409L242.219 266.244C253.383 253.256 260.105 236.395 260.105 218.053C260.105 177.153 226.952 144 186.053 144C145.153 144 112 177.153 112 218.053C112 258.953 145.153 292.105 186.053 292.105C204.395 292.105 221.256 285.384 234.244 274.219L237.32 277.409V286.409L271.025 320L288 303.025L254.409 269.32Z"
              />
              <path
                className="search-a-path-2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M185.92 268.96C157.678 268.96 134.88 246.162 134.88 217.92C134.88 189.678 157.678 166.88 185.92 166.88C214.162 166.88 236.96 189.678 236.96 217.92C236.96 246.162 214.162 268.96 185.92 268.96Z"
                fill="var(--color-white)"
              />
              <path
                className="vector"
                d="M203.916 202.08C207.929 202.08 211.44 205.617 211.44 209.66C211.44 213.702 207.929 217.239 203.916 217.239C199.903 217.239 196.392 213.702 196.392 209.66C196.392 205.617 199.903 202.08 203.916 202.08ZM176.328 209.66C176.328 213.702 172.817 217.239 168.804 217.239C164.791 217.239 161.28 213.702 161.28 209.66C161.28 205.617 164.791 202.08 168.804 202.08C172.817 202.08 176.328 205.617 176.328 209.66ZM186.36 232.399C195.138 232.399 202.863 236.037 207.377 241.545L200.254 248.72C197.997 245.031 192.63 242.505 186.36 242.505C180.09 242.505 174.723 245.031 172.466 248.72L165.343 241.545C169.857 236.037 177.582 232.399 186.36 232.399Z"
                fill="var(--color-gray-400)"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          className="ground-gradient"
          id="ground_gradient_fill_rule"
          x1="200"
          y1="272"
          x2="200"
          y2="352"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--color-gray-300)" />
          <stop offset="0.390625" stopColor="var(--color-gray-200)" />
          <stop offset="1" stopColor="var(--color-gray-200)" stopOpacity="0" />
        </linearGradient>
      </defs>
    </StyledNoResultsFoundIllustration>
  );
};

NoResultsFoundIllustration.propTypes = {
  /** Adds additional class to the component */
  className: PropTypes.string,
  /** Id value used for testing */
  dataTestId: PropTypes.string,
  /** Adjusts the size of the svg based upon the width. The aspect ratio is locked. */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Adds SVG accessibility title element */
  svgTitle: PropTypes.string,
};

export { NoResultsFoundIllustration };
